import { ReactNode } from "react";
import { useAuth } from "../hooks";
import { Navigate } from "react-router-dom";
import { RoutesEnum } from "./routes";

type ProtectedRouteProps = {
    children: ReactNode;
};

function ProtectedRoute({ children }: ProtectedRouteProps) {
    const { isAuthenticated } = useAuth();

    return isAuthenticated() ? (
        <>{children}</>
    ) : (
        <Navigate to={RoutesEnum.login} replace />
    );
}

export default ProtectedRoute;
